// The stage always fills the detected viewport. A decoded track fills it only
// when both have the same orientation; mismatches remain uncropped over the
// blurred fill so a landscape camera can never become a face-sized portrait crop.
export const CREATOR_CAMERA_FOREGROUND_FIT = "cover";
export const CREATOR_CAMERA_BACKGROUND_FIT = "cover";

export const getCameraCaptureProfile = (videoQuality = "auto", orientation = "auto") => {
  void videoQuality;
  void orientation;
  return {
    frameRate: 30,
  };
};

export const getCameraMediaConstraints = (
  videoQuality = "auto",
  orientation = "auto",
  facingMode = "user",
  exactFacingMode = false,
) => {
  const profile = getCameraCaptureProfile(videoQuality, orientation);
  return {
    facingMode: exactFacingMode ? { exact: facingMode } : { ideal: facingMode },
    frameRate: { ideal: profile.frameRate, max: profile.frameRate },
    resizeMode: { ideal: "none" },
  };
};

export const resetCameraZoom = async (track) => {
  const zoom = track?.getCapabilities?.()?.zoom;
  if (!zoom || !Number.isFinite(Number(zoom.min))) return false;
  await track.applyConstraints({ advanced: [{ zoom: Number(zoom.min) }] });
  return true;
};

export const releaseCameraPreview = (stream, mediaElements = []) => {
  stream?.getTracks?.().forEach((track) => track.stop());
  mediaElements.forEach((element) => {
    if (element) element.srcObject = null;
  });
};

export const getCameraDisplayFit = (_orientation, _settings = {}) => "cover";
